import type { AppProps } from 'next/app'
import React from 'react'
import { CSSReset, ThemeProvider, theme } from '@thirstycamel/ui'

import GlobalStyle from './_style'
import { AuthProvider } from '../context/AuthContext'
import { AuthGuard } from '../components/AuthGuard'
import App from 'next/dist/pages/_app'
class MyApp extends App<any> {
  public static getInitialProps = async ({ Component, ctx }) => {
    let pageProps = {}

    if (Component.getInitialProps) {
      pageProps = await Component.getInitialProps(ctx)
    }

    return { pageProps }
  }

  render() {
    const { Component, pageProps, store, err } = this.props

    return (
      <ThemeProvider theme={theme}>
        <AuthProvider>
          <CSSReset />
          <GlobalStyle />
          <AuthGuard>
            <Component {...pageProps} />
          </AuthGuard>
        </AuthProvider>
      </ThemeProvider>
    )
  }
}

export default MyApp
